import { Check, Flower2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function OurServicePackages() {
  const tiers = [{
    name: "Individual — Standard",
    tagline: "For the ambitious professional",
    price: "5,000",
    currency: "GHS",
    period: "/participant",
    featured: false,
    benefits: ["Full access to one selected course", "Training materials & resources", "Certificate of Completion", "1-hour 1-on-1 coaching session", "Hands-on workshops", "Access to recorded sessions"],
    cta: "Enrol Now"
  }, {
    name: "Starter Corporate Package",
    tagline: "For high-impact teams",
    price: "75,000",
    currency: "GHS",
    period: "/slot",
    featured: true,
    benefits: ["Up to 15 participants", "3 packed courses included", "4-week intensive training", "Materials & certification", "10% off for first booking", "Customized team workshops"],
    cta: "SECURE SLOT"
  }, {
    name: "Executive Capacity Building",
    tagline: "For organizational transformation",
    price: "Custom",
    currency: "",
    period: "Pricing",
    featured: false,
    benefits: ["Unlimited organizational access", "Strategic leadership consulting", "AI implementation roadmap", "Dedicated account manager", "On-site training delivery"],
    cta: "Contact Sales"
  }];
  return <section data-section-id="11" id="our-service-packages" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 md:w-16" style={{
            backgroundColor: "var(--primary)"
          }} />
            <span className="text-xs uppercase font-mono" style={{
            letterSpacing: "0.2em",
            color: "var(--primary)"
          }}>
              Enrolment Packages
            </span>
            <span className="h-px w-12 md:w-16" style={{
            backgroundColor: "var(--primary)"
          }} />
          </div>

          <h2 className="font-default text-foreground text-4xl md:text-5xl lg:text-6xl leading-[1.1] mb-6 max-w-3xl">
            Invest in your{" "}
            <em className="font-serif italic" style={{
            color: "var(--secondary)"
          }}>
              future
            </em>{" "}
            excellence.
          </h2>

          <p className="text-muted-foreground font-default text-base md:text-lg leading-relaxed max-w-[60ch]">
            Equipping professionals and organizations with the skills needed to thrive in today’s dynamic business environment through practical, high-impact training.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-6 items-stretch">
          {tiers.map((tier, i) => {
          const isFeatured = tier.featured;
          return <div key={i} data-index={i} className={`relative flex flex-col bg-card rounded-md p-10 md:p-14 transition-all ${isFeatured ? "lg:-translate-y-4 shadow-xl border-l-4" : "border border-border"}`} style={isFeatured ? {
            borderLeftColor: "var(--primary)",
            boxShadow: "20px 20px 0px rgba(165, 42, 42, 0.1)"
          } : {
            borderColor: "var(--border)"
          }}>
                {}
                {isFeatured && <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <div className="px-4 py-1.5 text-[10px] uppercase font-mono rounded-md" style={{
                backgroundColor: "var(--secondary)",
                color: "white",
                letterSpacing: "0.25em",
                fontWeight: 600
              }}>
                      Most Popular
                    </div>
                  </div>}

                {}
                <div className="text-xs uppercase font-mono mb-5" style={{
              letterSpacing: "0.2em",
              color: "var(--primary)",
              fontWeight: 600
            }}>
                  {tier.name}
                </div>

                {}
                <div className="flex items-center gap-3 mb-8">
                  <span className="h-px flex-1" style={{
                backgroundColor: "var(--border)"
              }} />
                  <Flower2 className="size-4" style={{
                color: "var(--primary)"
              }} />
                  <span className="h-px flex-1" style={{
                backgroundColor: "var(--border)"
              }} />
                </div>

                {}
                

                {}
                <p className="font-serif italic text-lg md:text-xl mb-8" style={{
              color: "var(--primary)"
            }}>
                  {tier.tagline}
                </p>

                {}
                <div className="h-px w-full mb-8" style={{
              backgroundColor: "var(--border)"
            }} />

                {}
                <ul className="flex flex-col gap-4 mb-10 flex-1">
                  {tier.benefits.map((benefit, bi) => <li key={bi} data-index={bi} className="flex items-start gap-3">
                      <Check className="size-4 mt-0.5 shrink-0" style={{
                  color: "var(--secondary)"
                }} />
                      <span className="font-default text-foreground text-[15px] leading-relaxed">
                        {benefit}
                      </span>
                    </li>)}
                </ul>

                {}
                <Link to={i === 0 || i === 1 ? "https://form.jotform.com/africabusinessschool12/course-application-form" : i === 2 ? "/ContactUs" : "#"} className="block w-full" target={i === 0 || i === 1 ? "_blank" : undefined} rel={i === 0 || i === 1 ? "noopener noreferrer" : undefined}>
                  {isFeatured ? <Button className="w-full h-12 font-mono uppercase text-xs hover:opacity-90 transition-all border-0 rounded-md" style={{
                backgroundColor: "var(--secondary)",
                color: "white",
                letterSpacing: "0.2em",
                fontWeight: 600
              }}>
                      {tier.cta}
                    </Button> : <Button variant="outline" className="w-full h-12 font-mono uppercase text-xs bg-transparent hover:bg-primary hover:text-white transition-all rounded-md" style={{
                borderColor: "var(--primary)",
                color: "var(--primary)",
                letterSpacing: "0.2em",
                fontWeight: 600
              }}>
                      {tier.cta}
                    </Button>}
                </Link>

                {}
                <p className="font-serif italic text-center text-xs mt-5 text-muted-foreground">
                  Flexible payment plans available
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}